import { render } from "./CharacterMovementPage.vue?vue&type=template&id=2b370ea1"
import script from "./CharacterMovementPage.vue?vue&type=script&lang=js"
export * from "./CharacterMovementPage.vue?vue&type=script&lang=js"

import "./CharacterMovementPage.vue?vue&type=style&index=0&id=2b370ea1&lang=css"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__